import { ReactComponent as ShoppingCart } from '../../../assets/svg/shoppingcart.svg';
import { ReactComponent as Home } from '../../../assets/svg/home.svg';
import { ReactComponent as Bell } from '../../../assets/svg/bell.svg';
import { ReactComponent as Download } from '../../../assets/svg/download.svg';
import { ReactComponent as Gift } from '../../../assets/svg/gift.svg';
import { ReactComponent as Graduate } from '../../../assets/svg/graduate.svg';
import { ReactComponent as Info } from '../../../assets/svg/info.svg';
import { ReactComponent as Interogation } from '../../../assets/svg/interogation.svg';
import { ReactComponent as Money } from '../../../assets/svg/money.svg';
import { ReactComponent as Pocket } from '../../../assets/svg/pocket.svg';
import { ReactComponent as Profile } from '../../../assets/svg/profile.svg';
import { ReactComponent as Puzzle } from '../../../assets/svg/puzzle.svg';
import { ReactComponent as Ranking } from '../../../assets/svg/ranking.svg';
import { ReactComponent as Refresh } from '../../../assets/svg/refresh.svg';
import { ReactComponent as UserGroup } from '../../../assets/svg/usergroup.svg';
import { ReactComponent as ArrowDown } from '../../../assets/svg/arrowdown.svg';
import { ReactComponent as RightArrow } from '../../../assets/svg/rightarrow.svg';
import { ReactComponent as LeftArrow } from '../../../assets/svg/leftarrow.svg';
import { ReactComponent as MapMarker } from '../../../assets/svg/mapmarker.svg';
import { ReactComponent as LabelTag } from '../../../assets/svg/labeltag.svg';
import { ReactComponent as MoreAbout } from '../../../assets/svg/moreabout.svg';
import { ReactComponent as Trash } from '../../../assets/svg/trash.svg';
import { ReactComponent as Search } from '../../../assets/svg/search.svg';
import { ReactComponent as AddPerson } from '../../../assets/svg/addperson.svg';
import { ReactComponent as Edit } from '../../../assets/svg/edit.svg';
import { ReactComponent as Upload } from '../../../assets/svg/upload.svg';
import { ReactComponent as Landscape } from '../../../assets/svg/landscape.svg';
import { ReactComponent as Plus } from '../../../assets/svg/plus.svg';
import { ReactComponent as Close } from '../../../assets/svg/close.svg';
import { ReactComponent as Form } from '../../../assets/svg/form.svg';
import { ReactComponent as EyeOff } from '../../../assets/svg/eyeoff.svg';
import { ReactComponent as EyeOn } from '../../../assets/svg/eyeon.svg';
import { ReactComponent as Warning } from '../../../assets/svg/warning.svg';
import { ReactComponent as Clock } from '../../../assets/svg/clock.svg';
import { ReactComponent as Play } from '../../../assets/svg/play.svg';
import { ReactComponent as BackArrow } from '../../../assets/svg/backarrow.svg';
import { ReactComponent as External } from '../../../assets/svg/external.svg';
import { ReactComponent as Link } from '../../../assets/svg/link.svg';
import { ReactComponent as Briefcase } from '../../../assets/svg/briefcase.svg';
import { ReactComponent as Phone } from '../../../assets/svg/phone.svg';
import { ReactComponent as Mail } from '../../../assets/svg/mail.svg';
import { ReactComponent as Logout } from '../../../assets/svg/logout.svg';
import { ReactComponent as ArrowUp } from '../../../assets/svg/arrowup.svg';
import { ReactComponent as BadgeCheck } from '../../../assets/svg/badgecheck.svg';
import { ReactComponent as Users } from '../../../assets/svg/users.svg';
import { ReactComponent as Calendar } from '../../../assets/svg/calendar.svg';
import { ReactComponent as XCircle } from '../../../assets/svg/xcircle.svg';
import { ReactComponent as SwitchVertical } from '../../../assets/svg/switchvertical.svg';
import { ReactComponent as Tick } from '../../../assets/svg/tick.svg';
import { ReactComponent as Filter } from '../../../assets/svg/filter.svg';
import { ReactComponent as DoubleArrow } from '../../../assets/svg/doublearrow.svg';
import { ReactComponent as DoubleArrowVertical } from '../../../assets/svg/doublearrowvertical.svg';
import { ReactComponent as Bank } from '../../../assets/svg/bank.svg';
import { ReactComponent as RoundedPlus } from '../../../assets/svg/roundedPlus.svg';
import { ReactComponent as College } from '../../../assets/svg/college.svg';
import { ReactComponent as Minus } from '../../../assets/svg/minus.svg';

export type Icon =
  | 'Play'
  | 'Close'
  | 'Home'
  | 'ShoppingCart'
  | 'Bell'
  | 'Download'
  | 'Gift'
  | 'Graduate'
  | 'Info'
  | 'Interogation'
  | 'Money'
  | 'Pocket'
  | 'Profile'
  | 'Puzzle'
  | 'Ranking'
  | 'Refresh'
  | 'ArrowDown'
  | 'LeftArrow'
  | 'RightArrow'
  | 'BackArrow'
  | 'UserGroup'
  | 'MoreAbout'
  | 'Trash'
  | 'Plus'
  | 'MapMarker'
  | 'LabelTag'
  | 'Landscape'
  | 'AddPerson'
  | 'Edit'
  | 'Upload'
  | 'Form'
  | 'Search'
  | 'Clock'
  | 'External'
  | 'Link'
  | 'Briefcase'
  | 'Phone'
  | 'Mail'
  | 'ArrowUp'
  | 'Logout'
  | 'BadgeCheck'
  | 'Users'
  | 'Calendar'
  | 'XCircle'
  | 'EyeOff'
  | 'Warning'
  | 'EyeOn'
  | 'SwitchVertical'
  | 'Tick'
  | 'Filter'
  | 'DoubleArrow'
  | 'DoubleArrowVertical'
  | 'Bank'
  | 'RoundedPlus'
  | 'College'
  | 'Minus';

export default {
  Play,
  Close,
  ShoppingCart,
  Home,
  Bell,
  Download,
  Gift,
  Graduate,
  Info,
  Interogation,
  Money,
  Pocket,
  Profile,
  Puzzle,
  Ranking,
  Refresh,
  ArrowDown,
  LeftArrow,
  RightArrow,
  BackArrow,
  UserGroup,
  MapMarker,
  LabelTag,
  MoreAbout,
  Trash,
  Search,
  Plus,
  AddPerson,
  Edit,
  Upload,
  Landscape,
  Form,
  Warning,
  External,
  Clock,
  Logout,
  ArrowUp,
  Link,
  Briefcase,
  Phone,
  Mail,
  Users,
  Calendar,
  BadgeCheck,
  XCircle,
  EyeOff,
  EyeOn,
  SwitchVertical,
  Tick,
  Filter,
  DoubleArrow,
  DoubleArrowVertical,
  Bank,
  RoundedPlus,
  College,
  Minus
};
